import { t } from '../i18n';

/**
 * The Theatrix frame — the settled content-display mechanism (Blueprint DR-06).
 * In the PoC it loads the local mock lesson page; in production the iframe src
 * becomes the real Theatrix URL on the same origin (cookies just work).
 */
export class LessonOverlay {
  private overlay = document.getElementById('lesson-overlay')!;
  private frame = document.getElementById('lesson-frame') as HTMLIFrameElement;
  private title = document.getElementById('lesson-title')!;
  private closeBtn = document.getElementById('lesson-close') as HTMLButtonElement;

  private onComplete: ((courseId: number) => void) | null = null;

  constructor() {
    this.closeBtn.textContent = t('close');
    this.closeBtn.addEventListener('click', () => this.close());
    window.addEventListener('message', (e: MessageEvent) => {
      const data = e.data as { type?: string; courseId?: number };
      if (data && data.type === 'theatrix-complete') {
        this.close();
        this.onComplete?.(data.courseId ?? 0);
      }
    });
  }

  get isOpen(): boolean {
    return this.overlay.style.display === 'block';
  }

  open(courseId: number, lessonName: string, onComplete: (courseId: number) => void): void {
    this.onComplete = onComplete;
    this.title.textContent = `${t('lesson_title')} — ${lessonName}`;
    this.frame.src = `./mock/theatrix.html?course=${courseId}`;
    this.overlay.style.display = 'block';
  }

  close(): void {
    this.overlay.style.display = 'none';
    this.frame.src = 'about:blank';
  }
}
